"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUserProfileUrl = exports.hasSnaps = void 0;
const web_env_1 = require("@snapchat/web-env");
function hasSnaps(story) {
    return (Array.isArray(story.snaps) &&
        story.snaps.length !== 0 &&
        story.snaps.every((snap) => snap?.snapUrls?.mediaUrl));
}
exports.hasSnaps = hasSnaps;
const generateUserProfileUrl = (username) => {
    const hostname = (typeof (0, web_env_1.getWindow)() !== "undefined" && (0, web_env_1.getWindow)()?.location.origin) ||
        "https://www.snapchat.com";
    if (hostname === "https://story.snapchat.com") {
        return `https://www.snapchat.com/add/${username}`;
    }
    return `${hostname}/add/${username}`;
};
exports.generateUserProfileUrl = generateUserProfileUrl;
//# sourceMappingURL=utils.js.map